import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../core/shared.module';
import { DirectivesModule } from '../directives/directives.module';
import { FilterModule } from '../filter/filter.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { UtilityModule } from '../utility/utility.module';
import { LogoutDialogComponent } from './dialogs/logout-dialog/logout-dialog.component';
import { NewCaseDialogComponent } from './dialogs/new-case-dialog/new-case-dialog.component';
import { NewCaseSearchClientsCardComponent } from './dialogs/new-case-dialog/new-case-search-clients/new-case-search-clients-card/new-case-search-clients-card.component';
import { NewCaseSearchClientsHeaderComponent } from './dialogs/new-case-dialog/new-case-search-clients/new-case-search-clients-header/new-case-search-clients-header.component';
import { NewCaseSearchClientsComponent } from './dialogs/new-case-dialog/new-case-search-clients/new-case-search-clients.component';
import { MainSidenavComponent } from './main-sidenav/main-sidenav.component';

@NgModule({
    declarations: [
        MainSidenavComponent,
        LogoutDialogComponent,
        NewCaseDialogComponent,
        NewCaseSearchClientsComponent,
        NewCaseSearchClientsHeaderComponent,
        NewCaseSearchClientsCardComponent
    ],
    imports: [
        UtilityModule,
        SharedModule,
        MaterialModule,
        NotificationsModule,
        AppRoutingModule,
        FilterModule,
        NgxMaskModule.forRoot(),
        DirectivesModule
    ],
    providers: [],
    exports: [MainSidenavComponent, LogoutDialogComponent],
    bootstrap: []
})
export class SideNavModule {}
